var r=function(r){switch(r){case"rounded":return"8px";case"circle":return"100%";default:return 0}};export{r as getBorderRadius};
